<template>
  <div class="arrange-mode-controls">
    <!---->
    <div class="arrange-mode-controls__key-frames-nav">
      <div v-tooltip.right-start="'Previous keyframe. arrowLeft'" class="arrange-mode-controls__button">
        <i class="material-icons" @click.stop="prevKeyFrame">arrow_backward</i>
      </div>
      <div v-tooltip.right-start="'Next keyframe. arrowRight'" class="arrange-mode-controls__button">
        <i class="material-icons" @click.stop="nextKeyFrame">arrow_forward</i>
      </div>
    </div>
    <!---->
    <div class="arrange-mode-controls__time">
      TIME :
      <div class="arrange-mode-controls__time-value">
        {{currentTime}}
      </div>
    </div>
    <!---->
    <div v-tooltip.right-start="'Inverse selection. ctrl+a'" class="arrange-mode-controls__button" @click.stop="invertSelection">
      <i v-if="selectInverse" class="material-icons">toggle_on</i>
      <i v-else class="material-icons">toggle_off</i>
    </div>
    <!---->
    <div v-if="selectedWaypoints.length > 1" class="arrange-mode-controls__alignement">
      <div class="arrange-mode-controls__label">
        ALIGN HORIZONTALLY:
      </div>
      <div v-tooltip.right-start="'Align selected bottom. shift+arrowDown'" class="arrange-mode-controls__button" @click.stop="alignBottom">
        <i class="material-icons">vertical_align_bottom</i>
      </div>
      <div v-tooltip.right-start="'Align selected middle. shift+m'" class="arrange-mode-controls__button" @click.stop="alignMiddle">
        <i class="material-icons">vertical_align_center</i>
      </div>
      <div v-tooltip.right-start="'Align selected top. shift+arrowUp'" class="arrange-mode-controls__button" @click.stop="alignTop">
        <i class="material-icons">vertical_align_top</i>
      </div>
      <div class="arrange-mode-controls__label">
        ALIGN VERTICALLY:
      </div>
      <div v-tooltip.right-start="'Align selected left. shift+arrowleft'" class="arrange-mode-controls__button" @click.stop="alignLeft">
        <i class="material-icons align-horizontal">vertical_align_bottom</i>
      </div>
      <div v-tooltip.right-start="'Align selected center. shift+c'" class="arrange-mode-controls__button" @click.stop="alignCenter">
        <i class="material-icons align-horizontal">vertical_align_center</i>
      </div>
      <div v-tooltip.right-start="'Align selected right. shift+arrowRight'" class="arrange-mode-controls__button" @click.stop="alignRight">
        <i class="material-icons align-horizontal">vertical_align_top</i>
      </div>
      <div v-if="selectedWaypoints.length > 2" class="arrange-mode-controls__label">
        SPREAD:
      </div>
      <div v-else class="arrange-mode-controls__label-inactive">
        SPREAD:
      </div>
      <div v-if="selectedWaypoints.length > 2" v-tooltip.right-start="'Spread vertically.'" class="arrange-mode-controls__button" @click.stop="verticalSpread">
        <i class="material-icons align-horizontal">linear_scale</i>
      </div>
      <div v-else v-tooltip.right-start="'Spread vertically.'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons align-horizontal">linear_scale</i>
      </div>
      <div v-if="selectedWaypoints.length > 2" v-tooltip.right-start="'Spread horizontally.'" class="arrange-mode-controls__button" @click.stop="horizontalSpread">
        <i class="material-icons">linear_scale</i>
      </div>
      <div v-else v-tooltip.right-start="'Spread horizontally.'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">linear_scale</i>
      </div>
      <div class="arrange-mode-controls__label">
        APPLY:
      </div>
      <div v-tooltip.right-start="'Apply to all selected. ctrl+shift+a'" class="arrange-mode-controls__button" @click.stop="applyToAllSelected">
        <i class="material-icons">format_paint</i>
      </div>
    </div>
    <!---->
    <div v-else class="arrange-mode-controls__alignement">
      <div class="arrange-mode-controls__label-inactive">
        ALIGN HORIZONTALLY:
      </div>
      <div v-tooltip.right-start="'Align selected bottom. shift+arrowDown'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">vertical_align_bottom</i>
      </div>
      <div v-tooltip.right-start="'Align selected middle. shift+m'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">vertical_align_center</i>
      </div>
      <div v-tooltip.right-start="'Align selected top. shift+arrowUp'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">vertical_align_top</i>
      </div>
      <div class="arrange-mode-controls__label-inactive">
        ALIGN VERTICALLY:
      </div>
      <div v-tooltip.right-start="'Align selected left. shift+arrowleft'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons align-horizontal">vertical_align_bottom</i>
      </div>
      <div v-tooltip.right-start="'Align selected center. shift+c'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons align-horizontal">vertical_align_center</i>
      </div>
      <div v-tooltip.right-start="'Align selected right. shift+arrowRight'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons align-horizontal">vertical_align_top</i>
      </div>
      <div class="arrange-mode-controls__label-inactive">
        SPREAD:
      </div>
      <div v-tooltip.right-start="'Spread vertically.'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons align-horizontal">linear_scale</i>
      </div>
      <div v-tooltip.right-start="'Spread horizontally.'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">linear_scale</i>
      </div>
      <div class="arrange-mode-controls__label-inactive">
        APPLY:
      </div>
      <div v-tooltip.right-start="'Apply to all selected. ctrl+shift+a'" class="arrange-mode-controls__button-inactive">
        <i class="material-icons">format_paint</i>
      </div>
    </div>
    <!---->
    <div class="arrange-mode-controls__label" v-tooltip.bottom-center="'use ALT-KEY while dragging or resizing a waypoint to snap to the Grid'">
      GRID
    </div>
    <input type="number" maxlength="2" min="2" max="100" v-model="grid.size" class="waypoints-list-item__input"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getFilter } from '../../../utils/filters'

export default {
  name: 'arrangeModeControls',

  props: {
    keyFramesTimes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },

  data() {
    return {
      selectInverse: false
    }
  },

  computed: {
    ...mapState(['keyFrame', 'grid']),
    ...mapGetters(['currentTime', 'getAllWaypointsByTimeAndTags', 'getAllScenesByTags']),

    selectedWaypoints: function () {
      return this.keyFrame.selectedWaypoints.map(swp => {
        return swp.wp
      })
    },

    activeScenes: function () {
      const activeScenes = this.getAllScenesByTags(getFilter('1')).filter(as => {
        return this.hasSceneSelectedWaypoint(as.scene, this.selectedWaypoints)
      })

      return activeScenes.map(as => as.scene)
    }
  },

  created() {
    this.keyEventUnsubscribe = this.keyEventSubscribe(['editor'], {
      'ArrowLeft': this.prevKeyFrame,
      'ArrowRight': this.nextKeyFrame,
      'ctrl+a': this.invertSelection,
      'shift+ArrowDown': this.alignBottom,
      'shift+M': this.alignMiddle,
      'shift+ArrowUp': this.alignTop,
      'shift+ArrowLeft': this.alignLeft,
      'shift+C': this.alignCenter,
      'shift+ArrowRight': this.alignRight,
      'ctrl+shift+A': this.applyToAllSelected
    })
  },

  mounted() {
    this.clearKeyFrame()
  },

  beforeDestroy() {
    this.keyEventUnsubscribe()
  },

  methods: {
    ...mapMutations(['setPlayerTime', 'resetSelection', 'clearKeyFrame', 'updateKeyFrame']),

    hasSceneSelectedWaypoint: function (scene, selectedWaypoints) {
      const waypoints = scene.waypoints || []

      const match = waypoints.reduce((acc, wp) => {
        return [
          ...acc,
          ...selectedWaypoints.filter(swp => {
            return swp === wp
          })
        ]
      }, [])

      return match.length > 0
    },

    prevKeyFrame: function () {
      const allKeyFramesDesc = [...this.keyFramesTimes].sort((a,b) => b - a)
      const prevKeyFrames = allKeyFramesDesc.filter((keyFrame) =>  parseFloat(keyFrame.toFixed(2)) < parseFloat( this.currentTime.toFixed(2)))

      this.moveToKeyFrame(prevKeyFrames[0] ? prevKeyFrames[0] : allKeyFramesDesc[0])
    },

    nextKeyFrame: function () {
      const allKeyFramesAsc = [...this.keyFramesTimes].sort((a,b) => a - b)
      const nextKeyFrames = allKeyFramesAsc.filter((keyFrame) =>  parseFloat(keyFrame.toFixed(2)) > parseFloat( this.currentTime.toFixed(2)))

      this.moveToKeyFrame(nextKeyFrames[0] ? nextKeyFrames[0] : allKeyFramesAsc[0])
    },

    moveToKeyFrame: function (newTime) {
      this.selectInverse = false
      this.clearKeyFrame()
      this.resetSelection()
      this.setPlayerTime(newTime)
    },

    invertSelection: function (e) {
      const waypoints = this.getAllWaypointsByTimeAndTags(this.currentTime, getFilter('1')) || []
      this.selectInverse = !this.selectInverse

      if(e) {
        e.preventDefault()
      }

      waypoints.forEach(wp => {
        this.updateKeyFrame(wp)
      })
    },

    applyToAllSelected: function () {
      const activeScenes = this.activeScenes

      activeScenes.forEach(activeScene => {
        const currentWaypoint = activeScene.waypoints.find(wp => {
          return parseFloat(wp.time.toFixed(2)) === parseFloat(this.currentTime.toFixed(2))
        })

        if (currentWaypoint) {
          activeScene.waypoints.forEach(wp => {
            wp.x = currentWaypoint.x
            wp.y = currentWaypoint.y
            wp.pw = currentWaypoint.pw
            wp.ph = currentWaypoint.ph
            wp.w = currentWaypoint.w
            wp.h = currentWaypoint.h
          })
        }
      })
    },

    alignBottom: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return b.y - a.y
        })

        const bottom = waypoints[0].y + (waypoints[0].ph / 2)

        waypoints.forEach((wp) => {
          wp.y = bottom - (wp.ph / 2)
        })
      }
    },

    alignMiddle: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.y - b.y
        })

        const middle = (waypoints.length % 2) === 0 ? (
          (waypoints[(waypoints.length / 2) - 1].y + waypoints[waypoints.length / 2].y) / 2
        ) : (
          waypoints[(waypoints.length - 1) / 2].y
        )

        waypoints.forEach((wp) => {
          wp.y = middle
        })
      }
    },

    alignTop: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.y - b.y
        })

        const top = waypoints[0].y - (waypoints[0].ph / 2)

        waypoints.forEach((wp) => {
          wp.y = top + (wp.ph / 2)
        })
      }
    },

    alignLeft: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.x - b.x
        })

        const left = waypoints[0].x - (waypoints[0].pw / 2)

        waypoints.forEach((wp) => {
          wp.x = left + (wp.pw / 2)
        })
      }
    },

    alignCenter: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.x - b.x
        })

        const center = (waypoints.length % 2) === 0 ? (
          (waypoints[(waypoints.length / 2) - 1].x + waypoints[waypoints.length / 2].x) / 2
        ) : (
          waypoints[(waypoints.length - 1) / 2].x
        )

        waypoints.forEach((wp) => {
          wp.x = center
        })
      }
    },

    alignRight: function () {
      if (this.selectedWaypoints.length > 0) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return b.x - a.x
        })

        const right = waypoints[0].x + (waypoints[0].pw / 2)

        waypoints.forEach((wp) => {
          wp.x = right - (wp.pw / 2)
        })   
      }
    },

    horizontalSpread: function () {
      if (this.selectedWaypoints.length > 2) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.x - b.x
        })

        const start = waypoints[0].x - (waypoints[0].pw / 2)
        const end = waypoints[waypoints.length - 1].x + (waypoints[waypoints.length - 1].pw / 2)
        const totalWidth = end - start

        const boxesWidth = waypoints.reduce((acc, wp) => {
          return acc + wp.pw
        }, 0)

        const totalInterval = totalWidth - boxesWidth
        const interval = totalInterval / (waypoints.length - 1)

        let boxLeft = start

        waypoints.forEach(wp => {
          wp.x = boxLeft + (wp.pw / 2)
          boxLeft += interval + wp.pw
        })
      }
    },

    verticalSpread: function () {
      if (this.selectedWaypoints.length > 2) {
        const waypoints = this.selectedWaypoints.sort((a,b) => {
          return a.y - b.y
        })

        const start = waypoints[0].y - (waypoints[0].ph / 2)
        const end = waypoints[waypoints.length - 1].y + (waypoints[waypoints.length - 1].ph / 2)
        const totalHeight = end - start

        const boxesHeight = waypoints.reduce((acc, wp) => {
          return acc + wp.ph
        }, 0)

        const totalInterval = totalHeight - boxesHeight
        const interval = totalInterval / (waypoints.length - 1)

        let boxUp = start

        waypoints.forEach(wp => {
          wp.y = boxUp + (wp.ph / 2)
          boxUp += interval + wp.ph
        })
      }
    }
  }
}
</script>
